import React from 'react';
import AntIcon from '@ant-design/icons';
import './styles.scss';

const Icon = ({ component, ...rest }) => {
  return <AntIcon component={component} {...rest} />;
};

Icon.propTypes = {};

export default Icon;

import { ReactComponent as ArrowUpIcon } from 'assets/images/icons/ArrowUpIcon.svg';
import { ReactComponent as CheckedIcon } from 'assets/images/icons/CheckedIcon.svg';
import { ReactComponent as ChervonLeftIcon } from 'assets/images/icons/ChervonLeftIcon.svg';
import { ReactComponent as ChervonRightIcon } from 'assets/images/icons/ChervonRightIcon.svg';
import { ReactComponent as ClockIcon } from 'assets/images/icons/ClockIcon.svg';
import { ReactComponent as CloseIcon } from 'assets/images/icons/CloseIcon.svg';
import { ReactComponent as CustomerIcon } from 'assets/images/icons/CustomerIcon.svg';
import { ReactComponent as EditIcon } from 'assets/images/icons/EditIcon.svg';
import { ReactComponent as EmailIcon } from 'assets/images/icons/EmailIcon.svg';
import { ReactComponent as ErrorIcon } from 'assets/images/icons/ErrorIcon.svg';
import { ReactComponent as FilterIcon } from 'assets/images/icons/FilterIcon.svg';
import { ReactComponent as KeyIcon } from 'assets/images/icons/KeyIcon.svg';
import { ReactComponent as MoreHorizontalIcon } from 'assets/images/icons/MoreHorizontalIcon.svg';
import { ReactComponent as ResetPasswordIcon } from 'assets/images/icons/ResetPasswordIcon.svg';
import { ReactComponent as SearchIcon } from 'assets/images/icons/SearchIcon.svg';
import { ReactComponent as StaffIcon } from 'assets/images/icons/StaffIcon.svg';
import { ReactComponent as TrashIcon } from 'assets/images/icons/TrashIcon.svg';
import { ReactComponent as ViewModuleIcon } from 'assets/images/icons/ViewModuleIcon.svg';
import { ReactComponent as ViewDetailsIcon } from 'assets/images/icons/ViewDetailsIcon.svg';
import { ReactComponent as VisaIcon } from 'assets/images/icons/VisaIcon.svg';
import { ReactComponent as MasterIcon } from 'assets/images/icons/MasterIcon.svg';
import { ReactComponent as NextIcon } from 'assets/images/icons/Next.svg';
import { ReactComponent as CardMTIcon } from 'assets/images/icons/Card-MT.svg';
import { ReactComponent as Plus } from 'assets/images/icons/Plus.svg';
import { ReactComponent as BankIcon } from 'assets/images/icons/BankIcon.svg';
import { ReactComponent as NoPaymentIcon } from 'assets/images/icons/NoPaymentIcon.svg';
import { ReactComponent as VisaLightIcon } from 'assets/images/icons/VisaLightIcon.svg';
import { ReactComponent as MasterLightIcon } from 'assets/images/icons/MasterLightIcon.svg';
import { ReactComponent as DollarIcon } from 'assets/images/icons/DollarIcon.svg';
import { ReactComponent as LoginAsAdmin } from 'assets/images/icons/LoginAsAdmin.svg';
import { ReactComponent as Calendar } from 'assets/images/icons/Calendar.svg';
import { ReactComponent as TransferRoleIcon } from 'assets/images/icons/TransferRoleIcon.svg';
import { ReactComponent as BannerImage } from 'assets/images/icons/banner-image.svg';
import { ReactComponent as VideoImage } from 'assets/images/icons/video-image.svg';
import { ReactComponent as CodeIcon } from 'assets/images/icons/CodeIcon.svg';
import { ReactComponent as DeleteWarning } from 'assets/images/icons/Warning.svg';
import { ReactComponent as LibraryUploadIcon } from 'assets/images/icons/LibraryUploadIcon.svg';
import { ReactComponent as UploadFileIcon } from 'assets/images/icons/UploadFileIcon.svg';
import { ReactComponent as CheckIcon } from 'assets/images/icons/CheckIcon.svg';
import { ReactComponent as HideEye } from 'assets/images/icons/HideEye.svg';
import { ReactComponent as NextArrowIcon } from 'assets/images/icons/NextArrowIcon.svg';
import { ReactComponent as PreArrowIcon } from 'assets/images/icons/PreArrowIcon.svg';
import { ReactComponent as TVIcon } from 'assets/images/icons/TVIcon.svg';
import { ReactComponent as PrerollIcon } from 'assets/images/icons/PrerollIcon.svg';
import { ReactComponent as NativeIcon } from 'assets/images/icons/NativeIcon.svg';
import { ReactComponent as CanvaIcon } from 'assets/images/icons/CanvaIcon.svg';
import { ReactComponent as TemplateIcon } from 'assets/images/icons/TemplateIcon.svg';
import { ReactComponent as TotalPurchasedIcon } from 'assets/images/icons/TotalPurchasedIcon.svg';
import { ReactComponent as PurchasedOrderIcon } from 'assets/images/icons/PurchasedOrderIcon.svg';
import { ReactComponent as AdVideoIcon } from 'assets/images/icons/AdVideoIcon.svg';
import { ReactComponent as AdBannerIcon } from 'assets/images/icons/AdBannerIcon.svg';
import { ReactComponent as BannerSetIcon } from 'assets/images/icons/BannerSetIcon.svg';
import { ReactComponent as SingleCalendar } from 'assets/images/icons/SingleCalendar.svg';
import { ReactComponent as UploadingIcon } from 'assets/images/icons/UploadingIcon.svg';
import { ReactComponent as WalletIcon } from 'assets/images/icons/WalletIcon.svg';
import { ReactComponent as VoucherIcon } from 'assets/images/icons/Voucher.svg';
import { ReactComponent as UndoIcon } from 'assets/images/icons/UndoIcon.svg';
import { ReactComponent as StackAdaptLogo } from 'assets/images/icons/StackAdaptLogo.svg';
import { ReactComponent as BasisLogo } from 'assets/images/icons/BasisLogo.svg';
import { ReactComponent as CTVIcon } from 'assets/images/icons/ctv.svg';
import { ReactComponent as CampaignIcon } from 'assets/images/icons/CampaignIcon.svg';
import { ReactComponent as AccountTierIcon } from 'assets/images/icons/AccountTier.svg';
import { ReactComponent as HistoryIcon } from 'assets/images/icons/History.svg';
import { ReactComponent as RefreshIcon } from 'assets/images/icons/RefreshIcon.svg';
import { ReactComponent as CardIcon } from 'assets/images/icons/CardIcon.svg';
import { ReactComponent as CloudDownloadIcon } from 'assets/images/icons/CloudDownloadIcon.svg';


export {
  ArrowUpIcon,
  CheckedIcon,
  ChervonRightIcon,
  ChervonLeftIcon,
  ClockIcon,
  CloseIcon,
  CustomerIcon,
  EditIcon,
  EmailIcon,
  ErrorIcon,
  FilterIcon,
  KeyIcon,
  MoreHorizontalIcon,
  ResetPasswordIcon,
  SearchIcon,
  StaffIcon,
  TrashIcon,
  ViewModuleIcon,
  ViewDetailsIcon,
  VisaIcon,
  MasterIcon,
  NextIcon,
  CardMTIcon,
  Plus,
  BankIcon,
  NoPaymentIcon,
  VisaLightIcon,
  MasterLightIcon,
  DollarIcon,
  LoginAsAdmin,
  Calendar,
  TransferRoleIcon,
  BannerImage,
  VideoImage,
  CodeIcon,
  DeleteWarning,
  LibraryUploadIcon,
  UploadFileIcon,
  CheckIcon,
  HideEye,
  NextArrowIcon,
  PreArrowIcon,
  TVIcon,
  PrerollIcon,
  NativeIcon,
  CanvaIcon,
  TemplateIcon,
  TotalPurchasedIcon,
  PurchasedOrderIcon,
  AdVideoIcon,
  AdBannerIcon,
  BannerSetIcon,
  SingleCalendar,
  UploadingIcon,
  WalletIcon,
  VoucherIcon,
  UndoIcon,
  StackAdaptLogo,
  BasisLogo,
  CTVIcon,
  CampaignIcon,
  AccountTierIcon,
  HistoryIcon,
  RefreshIcon,
  CardIcon,
  CloudDownloadIcon,
};
